import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarToggleService {
  private collapsed = new BehaviorSubject<boolean>(false);
  collapsed$ = this.collapsed.asObservable();

  setCollapsed(value: boolean) {
    this.collapsed.next(value);
  }

  toggle() {
    this.collapsed.next(!this.collapsed.value);
  }

  getCollapsed(): boolean {
    return this.collapsed.value;
  }
}
